import { apiNoAuth, apiAuth } from "./conection";

// apiNoAuth Functions
export const verifyService = {
  //verify email
  verifyEmail: async (verifyData) => {
    try {
      const response = await apiNoAuth.post(
        "/verify/verify-email-code",
        verifyData
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao verficar E-mail :", error);
      throw error;
    }
  },
  //resend Verification Code
  resendVerificationCode: async (email) => {
    try {
      const response = await apiNoAuth.post("/verify/resend-code", { email });
      return response.data;
    } catch (error) {
      console.error("Erro ao reenviar código de verificação:", error);
      throw error;
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await apiNoAuth.post("/verify/forgot-password", {
        email,
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao solicitar recuperação de senha:", error);
      throw error;
    }
  },

  resetPassword: async (email, code, newPassword) => {
    try {
      const response = await apiAuth.post("/verify/reset-password", {
        email,
        code,
        newPassword,
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao resetar a senha:", error);
      throw error;
    }
  },
};

// Debug logs
if (process.env.NODE_ENV !== "production") {
  console.log(
    "apiNoAuth initialized with base URL:",
    apiNoAuth.defaults.baseURL
  );
  console.log("apiNoAuth headers:", apiNoAuth.defaults.headers);
}
